import { BoosterType } from '../../../Card/BoosterType';
import CardStateHelper from '../../../Card/CardStateHelper';
import { ResponseStatus, ResponseType } from '../../../Game/GameActions';
import GameStateHelper from '../../../Game/GameStateHelper';
import { IGameState } from '../../../Game/IGameState';
import { helpFriend } from '../HelperFriendStateHelper';

export function helperFriendResponse(
    state: IGameState,
    success: boolean,
    friendId: string
) {
    state = GameStateHelper.restoreContext(state, {
        responseType: ResponseType.REQUEST_HELP,
        status: success ? ResponseStatus.SUCCESS : ResponseStatus.FAIL,
    });

    if (success) {
        state = CardStateHelper.playBooster(state, BoosterType.HF_PLUS_THREE);
        state = helpFriend(state, friendId);
    }

    return state;
}
